export default __webpack_public_path__ + "static/media/about-2.5f0d6ab7.png";